import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Product } from 'app/domain';
import { SolutionBuilderLoggerService } from 'app/domain/services/solution-builder-logger.service';
import { CustomValidators } from 'app/domain/validators/custom.validators';
import { ToastrService } from 'ngx-toastr';
import { SolutionBuilderClient } from '../../services/solution-builder-client.service';

@Component({
  selector: 'sb-custom-product-dialog-component',
  templateUrl: './custom-product-dialog.component.html',
  styleUrls: ['./custom-product-dialog.component.scss']
})
export class SbCustomProductDialogComponent extends DialogContentBase
  implements OnInit, AfterViewInit {
  fgCustomProduct: FormGroup;
  fcDescription: FormControl = new FormControl(
    '',
    Validators.compose([
      Validators.required,
      CustomValidators.preventWhitespaceOnly
    ])
  );
  fcQuantity: FormControl = new FormControl('', Validators.required);
  fcMsrp: FormControl = new FormControl('', Validators.required);
  fcCost: FormControl = new FormControl('', Validators.required);
  fcNotes: FormControl = new FormControl(
    '',
    Validators.compose([
      Validators.required,
      CustomValidators.preventWhitespaceOnly,
      Validators.maxLength(1000)
    ])
  );

  product: Product;

  constructor(
    private fb: FormBuilder,
    private solutionBuilderClient: SolutionBuilderClient,
    private logger: SolutionBuilderLoggerService,
    private toastr: ToastrService,
    dialog: DialogRef
  ) {
    super(dialog);
  }

  ngOnInit(): void {
    this.fgCustomProduct = this.fb.group({
      fcDescription: this.fcDescription,
      fcQuantity: this.fcQuantity,
      fcMsrp: this.fcMsrp,
      fcCost: this.fcCost,
      fcNotes: this.fcNotes
    });
  }

  ngAfterViewInit(): void {
    if (this.product) {
      this.fcDescription.setValue(this.product.description);
      this.fcNotes.setValue(this.product.externalNote);
      this.fcQuantity.setValue(this.product.defaultQuantity);
      this.fcMsrp.setValue(this.product.msrp);
      this.fcCost.setValue(this.product.costPricePerUnit);

      if (this.product.isSemiCustomProduct()) {
        this.fcDescription.disable();
      }
    } else {
      this.logger.debug('No Product was passed to the dialog.');
    }
  }

  onCancelAction(): void {
    this.dialog.close();
  }

  onConfirmAction(): void {
    if (this.fgCustomProduct.valid && this.product) {
      this.product.description = this.fcDescription.value;
      this.product.externalNote = this.fcNotes.value;
      this.product.msrp = this.fcMsrp.value;
      this.product.costPricePerUnit = this.fcCost.value;
      this.product.defaultQuantity = this.fcQuantity.value;

      // Need to explicitly call this so
      // the changes are saved locally.
      this.solutionBuilderClient.saveLocally();
      this.onCancelAction();
    } else {
      this.toastr.warning(
        'The Custom Product form is invalid.  Please fill out all fields before saving.'
      );
    }
  }
}
